<template>
  <div class='edit-customer-profile-form'>
    <v-form ref="form" v-model="valid">
      <v-text-field
        v-model="customerProfileDetails.firstName"
        class="left-input"
        :label="$t('registration.client.info.firstname')"
        :placeholder="$t('registration.client.info.firstname.placeholder')"
        dense
        outlined
        required
        autofocus
      />
      <v-text-field
        v-model="customerProfileDetails.lastName"
        :label="$t('registration.client.info.lastname')"
        :placeholder="$t('registration.client.info.lastname.placeholder')"
        dense
        outlined
        required
      />
      <v-text-field
          v-model="customerProfileDetails.jobTitle"
          :label="$t('registration.client.info.jobtitle')"
          :placeholder="$t('registration.client.info.jobtitle.placeholder')"
          dense
          outlined
          required
        />
      <vue-tel-input-vuetify
        v-model="customerProfileDetails.phone"
        mode="international"
        :placeholder="this.$t('registration.client.info.phonenumber.placeholder')"
        :label="$t('registration.client.info.phonenumber')"
        :selectLabel="$t('registration.client.info.phonenumber.country')"
        :rules="[rules.phone, rules.required]"
        outlined
        dense
        required
      />
      <v-autocomplete
        item-text="text"
        item-value="name"
        :title="cybersecurityKnowhowTitle"
        :items="knowhowOptionsData"
        v-model="customerProfileDetails.cybersecurityKnowhow"
        :label="$t('registration.client.info.cybersecurity.knowhow')"
        :placeholder="$t('registration.client.info.cybersecurity.knowhow.placeholder')"
        dense
        outlined
        required
        return-object
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { rules } from '@/utils/validationUtils';

export default {
  name: 'EditCustomerProfileForm',
  data() {
    return {
      valid: false,
    };
  },
  computed: {
    ...mapGetters([
      'customerProfileDetails',
      'registrationCybersecurityKnowhowOptions',
    ]),
    knowhowOptionsData() {
      return this.registrationCybersecurityKnowhowOptions.map(option => ({
        ...option,
        text: this.$pt('registration.client.info.cybersecurity.knowhow', option.name),
      }));
    },
    cybersecurityKnowhowTitle() {
      return this.customerProfileDetails.cybersecurityKnowhow?.text;
    },
    rules() {
      return {
        ...rules,
        required: v => rules.required(v) || this.$t('required'),
        phone: v => rules.phone(v) || this.$t('registration.client.info.phone.number.is.not.valid'),
      };
    },
  },
  watch: {
    valid() {
      this.$emit('changeFormValidation', this.valid);
    },
  },
};
</script>

<style lang='scss' scoped>
.edit-customer-profile-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
<style lang="scss">
.edit-customer-profile-form {
  .v-autocomplete {
    .v-input__append-inner {
      align-self: center !important;
      margin-top: 0 !important;
    }
  }
}
</style>
